export const MAX_DESKTOP_DESCRIPTION_LENGTH = 150;
export const MAX_MOBILE_DESCRIPTION_LENGTH = 85;
